export default "__VITE_ASSET__UE$u$Wc0__"